import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import ForgotPasswordModal from './ForgotPasswordModal';

import {
    sendResetPasswordEmail as sendResetPasswordEmailAction,
    setResetPasswordEmailStatus as setResetPasswordEmailStatusAction,
} from '../../actions/forgotPassword';

import { LOG_IN_FORM } from '../../constants';

const _mapStateToProps = (state) => {
    const { authentication, status } = state;

    return {
        resetPasswordEmailStatus: status.resetPasswordEmailStatus,
        usesNewStyles: authentication.featureFlags.launchAuthenticationRefactor,
        previousFormEmail: formValueSelector(LOG_IN_FORM)(state, 'email'),
    };
};

const _mapDispatchToProps = {
    handleForgotPassword: sendResetPasswordEmailAction,
    setResetPasswordEmailStatus: setResetPasswordEmailStatusAction,
};

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(ForgotPasswordModal);
